import { Box, Typography } from "@mui/material";
import FinancialsTable from "models/backoffice/modelComponents/FinancialsTable";
import Slide from "models/backoffice/slideDesign/Slide";
import SlideBullets from "models/backoffice/slideDesign/SlideBullets";
import SlideSection from "models/backoffice/slideDesign/SlideSection";
import SlideSectionText from "models/backoffice/slideDesign/SlideSectionText";
import SlideSectionTitle from "models/backoffice/slideDesign/SlideSectionTitle";
import SlideSectionWrapper from "models/backoffice/slideDesign/SlideSectionWrapper";
import SlideTitle from "models/backoffice/slideDesign/SlideTitle";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { useConfigurationLinks } from "../DealHome";
import SlideConfigButton from "models/backoffice/slideDesign/SlideConfigButton";

const DealSlide2 = forwardRef(
  ({ dealVisualizationInformation, scaleActive }, ref) => {
    const configurationLinks = useConfigurationLinks(
      dealVisualizationInformation,
    );
    const {
      deal,
      deal_fund,
      deal_information,
      deal_reporting,
      deal_exit,
      fund,
      captable,
      stored_portfolio,
      valuation_period,
      financial_data_vals,
      financial_data_types,
    } = dealVisualizationInformation || {};
    const { t } = useTranslation("translation");

    return (
      <Slide
        slideWidth={1000}
        scaleActive={scaleActive}
        loading={!dealVisualizationInformation}
      >
        {dealVisualizationInformation && (
          <>
            <SlideConfigButton configurationLinks={configurationLinks} />
            <SlideTitle size={2}>
              {deal?.logo?.url && (
                <img
                  loading="lazy"
                  src={deal?.logo?.url}
                  alt="Logo"
                  style={{
                    maxWidth: 100,
                    maxHeight: 21.83,
                    width: "auto",
                    height: "auto",
                    display: "block",
                    backgroundColor: "transparent",
                  }}
                />
              )}
            </SlideTitle>
            <SlideSectionWrapper ref={ref}>
              <SlideSectionTitle sx={{ height: 32 }}>
                {t("Financials")}
              </SlideSectionTitle>
              <SlideSectionText noPadding>
                <FinancialsTable
                  deal={deal}
                  fund={fund}
                  valuation_period={valuation_period}
                  financial_data_types={financial_data_types}
                  financial_data_vals={financial_data_vals}
                />
              </SlideSectionText>
              {/*
            <SlideSection size={4} borderRight>
              <SlideSectionTitle>Status of value creation</SlideSectionTitle>
              <SlideSectionText>
                <SlideBullets value={deal_information?.investment_rationale} />
              </SlideSectionText>
            </SlideSection>
            <SlideSection size={4} borderRight>
              <SlideSectionTitle>
                Comments related to last period
              </SlideSectionTitle>
              <SlideSectionText>
                <SlideBullets value={deal_information?.risks} />
              </SlideSectionText>
            </SlideSection>
            <SlideSection size={4}>
              <SlideSectionTitle>Outlooks</SlideSectionTitle>
              <SlideSectionText>
                <SlideBullets value={deal_information?.value_creation_plan} />
              </SlideSectionText>
            </SlideSection>
            */}
            </SlideSectionWrapper>
          </>
        )}
      </Slide>
    );
  },
);

export default DealSlide2;
